import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Layout from "../components/layout"
import Project from "../components/project"

const randomGenerator = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1)) + min
}

const Index = () => {
  const data = useStaticQuery(graphql`
    {
      allProjectsJson {
        edges {
          node {
            id
            title
            description
            photo
            theme
            image {
              childImageSharp {
                fluid(maxWidth: 2014, quality: 100) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    }
  `)
  const edges = data.allProjectsJson.edges
  const randomPosition = randomGenerator(0, edges.length - 1)
  const randomProject = edges[randomPosition].node
  return (
    <Layout>
      <Project
        slide={randomProject.id}
        title={randomProject.title}
        imageData={randomProject.image.childImageSharp.fluid}
        description={randomProject.description}
        photo={randomProject.photo}
        theme={randomProject.theme}
      />
    </Layout>
  )
}

export default Index
